module.exports = __webpack_public_path__ + "img/arrow-down-circle.3710d77c.svg";